import { render, staticRenderFns } from "./POLifecycleGuide.vue?vue&type=template&id=02b5fc5e&scoped=true"
import script from "./POLifecycleGuide.vue?vue&type=script&lang=ts"
export * from "./POLifecycleGuide.vue?vue&type=script&lang=ts"
import style0 from "./POLifecycleGuide.vue?vue&type=style&index=0&id=02b5fc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5fc5e",
  null
  
)

export default component.exports